import get from './get';

/**
 *
 * */
var transformAddress = function transformAddress(address) {
  var citycode = get(address, 'properties.citycode', '');
  var city = get(address, 'properties.city', '');
  var fullAddress = get(address, 'properties.label', '');
  var type = get(address, 'properties.type');
  var postcode = get(address, 'properties.postcode', '');
  var shortName = get(address, 'properties.shortName', '');
  return {
    city: city,
    country: 'France',
    longitude: get(address, 'geometry.coordinates[0]', ''),
    latitude: get(address, 'geometry.coordinates[1]', ''),
    number: get(address, 'properties.housenumber', ''),
    street: type === 'street' ? get(address, 'properties.name', '') : get(address, 'properties.street', ''),
    zipCode: postcode,
    citycode: citycode,
    fullAddress: fullAddress,
    type: type,
    id: get(address, 'properties.id'),
    label: "".concat(get(address, 'properties.label'), " ").concat(postcode.length > 0 ? "(".concat(postcode, ")") : ''),
    location: get(address, 'geometry'),
    shortName: shortName,
    rawData: address
  };
};

export default transformAddress;
//# sourceMappingURL=address.js.map